import { useQuery } from "@apollo/client/react";
import { graphql, type ResultOf, type VariablesOf } from "@tucan/graphql";

const QUERY = graphql(`
  query getCompanyFileMetadataById($id: ID!) {
    data: getCompanyFileMetadataById(id: $id) {
      url
      name
      expiry
    }
  }
`);

type Data = ResultOf<typeof QUERY>;
type Variables = VariablesOf<typeof QUERY>;

export const useCompanyFileMetadataQuery = (
  options: useQuery.Options<Data, Variables>,
): useQuery.Result<Data, Variables> =>
  useQuery<Data, Variables>(QUERY, options);
